// extracted by mini-css-extract-plugin
export default {"movies__container":"MovieCard_movies__container__w2Nde"};